import type { ServerListItem } from '@/types/fleet';

/** Escapes a single CSV cell — quotes when it contains a comma/quote/newline. */
function escapeCell(value: string): string {
  if (/[",\n\r]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }

  return value;
}

const COLUMNS: Array<{ header: string; pick: (s: ServerListItem) => string }> = [
  { header: 'name', pick: (s) => s.name },
  { header: 'status', pick: (s) => s.status },
  { header: 'role', pick: (s) => s.role },
  { header: 'provider', pick: (s) => s.provider },
  { header: 'public_ip', pick: (s) => s.public_ip },
  { header: 'continent', pick: (s) => s.region.continent },
  { header: 'country', pick: (s) => s.region.country },
  { header: 'city', pick: (s) => s.region.city },
  { header: 'last_seen_at', pick: (s) => s.last_seen_at ?? '' },
  { header: 'protocols', pick: (s) => s.protocols.map((p) => p.protocol).join('; ') },
];

/** Serializes the current server table view to a CSV string. */
export function serversToCsv(rows: ServerListItem[]): string {
  const header = COLUMNS.map((c) => c.header).join(',');
  const body = rows.map((row) =>
    COLUMNS.map((c) => escapeCell(c.pick(row))).join(','),
  );

  return [header, ...body].join('\r\n');
}

/** Triggers a client-side download of `content` as a named file. */
export function downloadCsv(content: string, filename: string): void {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
